import React from 'react'
import '../../CSS/style.css';
export default function Section5() {
    const OurTeam = [
        { photo: 'Team1.svg', name: "Guy Hawkins", description: "Together, we challenge ourselves for a better tomorrow by meaningful designs that help live our best life and maintain lasting relevance." },
        { photo: 'Team1.svg', name: "Guy Hawkins", description: "Together, we challenge ourselves for a better tomorrow by meaningful designs that help live our best life and maintain lasting relevance." },
        { photo: 'Team1.svg', name: "Guy Hawkins", description: "Together, we challenge ourselves for a better tomorrow by meaningful designs that help live our best life and maintain lasting relevance." }

    ]
    return (
        <div className='min-h-screen pt-10 pb-20 text-white bg-black flex items-center'>
            <div>
                <h1 className='text-center text-4xl font-semibold'>Our Team</h1>
                <div className=' grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 lg:gap-20 w-[85%] mx-auto mt-5'>
                    {OurTeam.map((item, index) => (
                        <div key={index}>
                            <div className='px-3 pb-3 rounded-lg relative bg-[#3F3F3F42] my-shape'>
                                <div className='px-5 pb-14 relative'>
                                    <img className='mx-auto' src={`/assets/other/${item.photo}`}></img>
                                    <p className='mt-2 text-lg font-semibold'>{item.name}</p>
                                    <div className='relative'>
                                        <div className='absolute'><img src='/assets/other/quote.svg'></img></div>
                                        <p className='text-sm'> <span className='ml-6'></span>{item.description}</p>
                                    </div>
                                    <button className='mt-2 w-10 h-10'><img src='/assets/other/ArrowRight.svg'></img></button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}